/* angular:styles/component:css;a69fa414325a926fb2eaa186d38f1debf695a8488a6dba426be3002091557723;/app/src/app/shared/animations/deletable-item-list.component.ts */
.avoid-clicks {
  pointer-events: none;
  display: none;
}
.disableDiv {
  pointer-events: none;
}
.plus-img-padding {
  padding: 3px 0px;
  margin-inline-start: -2px;
  margin-inline-end: -2px;
}
.cross-img-padding {
  width: 12px;
  height: 12px;
  fill: #cccccc;
  margin-top: 5px;
  z-index: 50;
}
.white-icon {
  fill: white;
}
.visibilityToggle {
  width: 14px;
  height: 14px;
  font-size: 10px;
  position: absolute;
  right: 12px;
  bottom: 10px;
  padding: 6px;
  cursor: pointer;
}
.parent-list {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  max-width: 100%;
}
.child {
  margin-right: 8px;
  max-width: 100%;
}
.button {
  max-width: 100%;
  background-color: #333333;
  height: 28px;
  border-radius: 14px;
  margin-bottom: 3px;
  padding: 5px 32px 8px 10px;
  position: relative;
  display: -webkit-box;
}
.button-grey {
  max-width: 100%;
  background-color: #c8c7cc;
  height: 28px;
  border-radius: 14px;
  margin-bottom: 3px;
  padding: 5px 32px 8px 10px;
  position: relative;
  display: -webkit-box;
}
.delete-button {
  position: absolute;
  right: 4px;
  padding: 6px;
  cursor: pointer;
}
.plus-button {
  width: 28px;
  height: 28px;
  border-radius: 19px;
  background-color: #578a6b;
  margin-top: 0px;
  display: flex;
  justify-content: center;
  cursor: pointer;
}
.disable-selection {
  -webkit-touch-callout: none;
  -webkit-user-select: none;
  -khtml-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}
.white-filter {
  filter: brightness(0) invert(1);
}
.edit-span {
  font-family: Lato;
  font-size: 12px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: 0.8px;
  color: #ffffff;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
  margin-top: 1px;
  margin-bottom: -1px;
  padding-left: 2px;
  max-width: 100%;
  outline: none;
}
.tab-closed {
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
  background-color: #578a6b;
  border: none;
  cursor: pointer;
  padding: 4px 9px;
  width: fit-content;
  -webkit-border-radius: 19px;
  -moz-border-radius: 19px;
  border-radius: 19px;
  position: relative;
}
.tab-opened-end,
.tab-opened {
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
  cursor: pointer;
  float: left;
  background-color: #ffffff;
  font-family: "Lato-Bold";
  padding: 4px 9px;
  height: 28px;
  -webkit-borderradius: 19px 19px 0px 0px;
  -moz-border-radius: 19px 19px 0px 0px;
  border-radius: 19px 19px 0px 0px;
  z-index: 1;
  -webkit-box-shadow: 2px 4px 12px 2px rgba(0, 0, 0, 0.2);
  -moz-box-shadow: 2px 4px 12px 2px rgba(0, 0, 0, 0.2);
  box-shadow: 2px 4px 12px 2px rgba(0, 0, 0, 0.2);
}
.tab-opened-end:before,
.tab-opened-end:after,
.tab-opened:before,
.tab-opened:after {
  content: "";
  position: absolute;
  height: 20px;
  width: 30px;
  bottom: 0;
  transform: scale(-1, -1);
  margin-bottom: 14px;
  margin-left: 40px;
}
.tab-opened:before {
  left: -10px;
  border-radius: 0 15px 0 0;
  -moz-border-radius: 0 15px 0 0;
  -webkit-border-radius: 0 15px 0 0;
  -webkit-box-shadow: 15px 0 0 0 #ffffff;
  box-shadow: 15px 0 0 0 #ffffff;
  z-index: 5;
}
.tab-opened:after {
  right: -10px;
  border-radius: 0 15px 0 0;
  -moz-border-radius: 0 15px 0 0;
  -webkit-border-radius: 0 15px 0 0;
  -webkit-box-shadow: -15px 0 0 0 #ffffff;
  box-shadow: -15px 0 0 0 #ffffff;
  z-index: 5;
}
.box-content-end,
.box-content {
  background-color: #ffffff;
  color: #f2eee7;
  overflow-y: hidden;
  max-height: 0;
  z-index: 2;
}
.box-content {
  -webkit-border-radius: 19px;
  -moz-border-radius: 19px;
  border-radius: 19px;
  z-index: 2;
}
.box-content-end {
  -webkit-border-radius: 0px 19px 19px 19px;
  -moz-border-radius: 0px 19px 19px 19px;
  border-radius: 0px 19px 19px 19px;
  z-index: 2;
}
.box-content-end.opened,
.box-content.opened {
  margin-top: 36px;
  overflow-y: visible;
  transition: max-height 0.5s ease-out;
  height: auto;
  max-height: 1000px;
  -webkit-box-shadow: 2px 4px 12px 2px rgba(0, 0, 0, 0.2);
  -moz-box-shadow: 2px 4px 12px 2px rgba(0, 0, 0, 0.2);
  box-shadow: 2px 4px 12px 2px rgba(0, 0, 0, 0.2);
  z-index: 2;
  position: absolute;
}
.box-content-end.opened:before {
  content: "";
  display: block;
  position: absolute;
  top: -12px;
  left: 0;
  height: 16px;
  width: 30px;
  background-color: white;
  z-index: 3;
}
.box-curve {
}
.box-curve:before {
  content: "";
  position: absolute;
  height: 12px;
  width: 30px;
  bottom: 0;
  transform: scale(-1, -1);
  margin-left: 41px;
  z-index: 2;
  background-color: unset;
  top: -12px;
}
.box-curve:before {
  left: -10px;
  border-radius: 0 15px 0 0;
  -moz-border-radius: 0 15px 0 0;
  -webkit-border-radius: 0 15px 0 0;
  -webkit-box-shadow: 15px 0 0 0 #ffffff;
  box-shadow: 15px 0 0 0 #ffffff;
}
.box-curve:after {
  right: -10px;
  border-radius: 0 15px 0 0;
  -moz-border-radius: 0 15px 0 0;
  -webkit-border-radius: 0 15px 0 0;
  -webkit-box-shadow: -15px 0 0 0 #ffffff;
  box-shadow: -15px 0 0 0 #ffffff;
}
.form-div {
  position: relavtive;
  padding-left: 16px;
  padding-right: 16px;
}
.form-img {
  position: absolute;
  left: 16px;
  top: 12px;
}
.form-text {
  width: 218px;
  border: 0px;
  height: 38px;
  font-family: Lato;
  font-size: 14px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  padding-inline-start: 24px;
  color: #333333;
}
input:focus {
  outline: none;
}
.line {
  height: 1px;
  background-color: #c8c7cc;
}
::-webkit-scrollbar {
  width: 5px;
}
::-webkit-scrollbar-thumb {
  background: #d8d8d8;
  border-radius: 3px;
  padding: 16px 13px;
}
.items-container {
  padding-left: 8px;
  padding-right: 8px;
  margin-right: 8px;
  overflow-y: auto;
  overflow-x: hidden;
  max-height: 160px;
}
.item {
  width: 234px;
  height: 33px;
  border-radius: 20px;
  background-color: #ffffff;
  cursor: pointer;
  position: relative;
}
.item-text {
  position: absolute;
  left: 8px;
  top: 8px;
  vertical-align: sub;
  font-family: Lato;
  font-size: 14px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #333333;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  max-width: 220px;
  cursor: pointer;
}
.spacer {
  padding-bottom: 8px;
}
/*# sourceMappingURL=deletable-item-list.component.css.map */
